"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reactivateSURights = exports.revokeSURights = exports.revokeInvitation = exports.acceptInvitation = exports.rejectInvitation = exports.sendInvitation = exports.fetchInvitations = exports.fetchGupis = void 0;
const getRequestOptions = async (stage, method) => {
    const requestHeaders = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    };
    const options = {
        resourceHostId: `myvw-gupis-${stage}`,
        method: method,
        headers: requestHeaders,
        credentials: 'same-origin',
        mode: 'cors',
        redirect: 'follow',
        referrer: 'no-referrer',
    };
    return options;
};
const fetchGupis = async (authService, url, options) => {
    return authService
        .fetch(url, options)
        .then((response) => {
        if (!response.ok) {
            throw new Error(`Fetch Gupis request failed with ${response.status}`);
        }
        if (response.status === 201 || response.status === 204) {
            return null;
        }
        return response.json();
    })
        .then((data) => {
        return data;
    })
        .catch((error) => {
        if (error instanceof Error) {
            console.error(`Fetch Gupis request failed with ${error.message}`);
        }
        else {
            console.error(`Fetch Gupis request: ${error}`);
        }
    });
};
exports.fetchGupis = fetchGupis;
const fetchInvitations = async (authService, gdcType, stage) => {
    const options = await getRequestOptions(stage, 'GET');
    return (0, exports.fetchGupis)(authService, `v1/guestuserplus/invitations?gdc=${gdcType}`, options);
};
exports.fetchInvitations = fetchInvitations;
const sendInvitation = async (authService, stage, invitationBody, gdcType) => {
    const options = await getRequestOptions(stage, 'POST');
    options.body = JSON.stringify({
        '2fmToken': invitationBody.fmToken,
        vin: invitationBody.vin,
        guSsoId: invitationBody.inviteeID,
    });
    return (0, exports.fetchGupis)(authService, `v1/guestuserplus/invitations?gdc=${gdcType}`, options);
};
exports.sendInvitation = sendInvitation;
const invitationAction = async (authService, stage, invitationID, requestMethod, gdcType, action) => {
    const options = await getRequestOptions(stage, requestMethod);
    return (0, exports.fetchGupis)(authService, `v1/guestuserplus/invitations/${invitationID}${action ? '/' + action : ''}?gdc=${gdcType}`, options);
};
const rejectInvitation = async (authService, stage, invitationID, gdcType) => {
    return invitationAction(authService, stage, invitationID, 'PUT', gdcType, 'reject');
};
exports.rejectInvitation = rejectInvitation;
const acceptInvitation = async (authService, stage, invitationID, gdcType) => {
    return invitationAction(authService, stage, invitationID, 'PUT', gdcType, 'accept');
};
exports.acceptInvitation = acceptInvitation;
const revokeInvitation = async (authService, stage, invitationID, gdcType) => {
    const options = await getRequestOptions(stage, 'DELETE');
    return (0, exports.fetchGupis)(authService, `v1/guestuserplus/invitations/${invitationID}?gdc=${gdcType}`, options);
};
exports.revokeInvitation = revokeInvitation;
const revokeSURights = async (authService, stage, reactivationBody, gdcType) => {
    const options = await getRequestOptions(stage, 'DELETE');
    options.body = JSON.stringify({
        vin: reactivationBody.vin,
        guSsoId: reactivationBody.guSsoId,
    });
    return (0, exports.fetchGupis)(authService, `v1/guestuserplus/permissions/revoke?gdc=${gdcType}`, options);
};
exports.revokeSURights = revokeSURights;
const reactivateSURights = async (authService, stage, reactivationBody, gdcType) => {
    const options = await getRequestOptions(stage, 'POST');
    options.body = JSON.stringify({
        vin: reactivationBody.vin,
        guSsoId: reactivationBody.guSsoId,
    });
    return (0, exports.fetchGupis)(authService, `v1/guestuserplus/permissions/reactivate?gdc=${gdcType}`, options);
};
exports.reactivateSURights = reactivateSURights;
//# sourceMappingURL=fetch.js.map